<template>
  <!-- 预约获取手机号弹窗 -->
  <div class="order_phone" v-show="show_phone_number">
    <div class="mask" @touchmove.prevent></div>
    <div
      class="content"
      :class="{
        phone_scale: show_phone_number,
        phone_scale_ipad: show_phone_number && is_ipad,
      }"
    >
      <div class="title">活动预约</div>
      <div class="input_number" @click="inputFocus">
        <input
          placeholder="请输入手机号"
          ref="number_input"
          v-model="phone_number"
        />
      </div>
      <div class="order_tips">*预约成功后，开抢时第1时间接收活动提醒</div>
      <div class="order_btn" @click="submit">立即预约</div>
      <div class="close_btn" @click="close">
        <img src="../img/close-btn.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { unfix } from "../js/fix_ele";

// api
import { phoneReservation } from "../api/phone_reservation.api";

const { log } = console;
export default {
  data() {
    return {
      phone_number: "",
    };
  },
  computed: {
    ...mapState(["xdevice", "show_phone_number", "activity_name", "is_ipad"]),
  },
  methods: {
    ...mapMutations(["SET_SHOW_PHONE_NUMBER", "SET_RESERVATION_STATUS"]),
    close() {
      let fixele = document.querySelector(".home");
      unfix(fixele);

      this.phone_number = "";
      this.SET_SHOW_PHONE_NUMBER(false);
    },
    // 处理键盘拉起不归位问题，暂不调用
    windowBack() {
      window.scrollTo(0, 0);
    },
    // 处理键盘拉起不归位问题，暂不调用
    windowInView(e) {
      e.target.scrollIntoView(true);
    },
    
    inputFocus() {
      this.$refs.number_input.focus();
    },
    // 提交
    submit(e) {
      if (!this.checkPhone()) return false;
      this.reservationReq();
    },
    // 校验手机号
    checkPhone() {
      const number = this.phone_number;
      if (number == "") {
        this.$showToast("请填写你的联系方式");
        return false;
      } else if (!/^1[3456789]\d{9}$/.test(number)) {
        this.$showToast("请输入正确的手机号码");
        return false;
      }

      return true;
    },

    // 处理接口返回非200
    handleResErr(res) {
      log(res);
      this.$showToast(res.message);
    },
    // 预约接口
    reservationReq() {
      let data = {
        phone: this.phone_number,
        activity_name: this.activity_name,
      };
      let headers = {
        "X-Device": this.xdevice,
      };
      phoneReservation({ data, headers })
        .then((res) => {
          res = this.$formatAxiosRes(res);
          log("手机号预约成功--", res);
          ![200].includes(res.code) && this.reservationFail(res);
          [200].includes(res.code) && this.reservationSuccess();
        })
        .catch((err) => {
          log("手机号预约错误--", err);
        });
    },
    // 预约成功
    reservationSuccess() {
      log("进入预约成功");
      this.$showToast("恭喜预约成功~11月6日 11：30限量开抢！");
      this.$doTrack({ name: "立即预约", IsOrderSuccess: 1 });
      this.SET_RESERVATION_STATUS(true);
      // setTimeout(() => {
      this.close();
      // }, 1500);
    },
    // 预约失败
    reservationFail(res) {
      this.handleResErr(res);
      this.$doTrack({ name: "立即预约", IsOrderSuccess: 0 });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../css/common.scss";
.order_phone {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}
.content {
  @include boxsize(560, 400);
  @include hcenter(560);
  background-color: #fff;
  border-radius: trans(24);
  position: absolute;
  top: 31%;
  z-index: 1;
  .title {
    @include fontstyle(#4a2525, 40);
    font-weight: bold;
    line-height: 1.15;
    text-align: center;
    margin-top: trans(43);
  }
  .input_number {
    @include boxsize(474, 84);
    @include layout(flex-start, center);
    border: trans(2) solid #4a2525;
    border-radius: trans(20);
    margin: 0 auto;
    margin-top: trans(30);
    input {
      @include fontstyle(#4a2525, 30);
      width: trans(440);
      height: trans(60);
      margin-left: trans(30);
      // border:1px solid #000;
    }
  }
  .order_btn {
    @include boxsize(474, 84);
    @include fontstyle(#4a2525, 30);
    @include layout(center, center);
    font-weight: bold;
    background-color: #fce04e;
    border-radius: trans(42);
    margin: 0 auto;
    margin-top: trans(30);
  }
}
.phone_scale {
  animation: phoneScale 0.2s 0.2s ease-in-out both;
}
@keyframes phoneScale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
.phone_scale_ipad {
  animation: phoneScaleIpad 0.2s 0.2s ease-in-out both;
}
@keyframes phoneScaleIpad {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(0.8);
  }
}
.close_btn {
  @include boxsize(58, 58);
  @include hcenter(58);
  position: absolute;
  bottom: trans(-205);
  img {
    width: 100%;
    display: block;
  }
}
.order_tips {
  @include fontstyle(#4a2525, 22);
  text-align: center;
  line-height: 1.15;
  margin-top: trans(20);
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/OrderPhone.vue